import { Controller } from "@hotwired/stimulus"
import { Jodit } from "jodit"
import "jodit/esm/plugins/all.js"
import axios from "axios"
// import hotkeys from "hotkeys-js" - nie działa razem z jodit poprawnie

export default class extends Controller {
  static targets = ["editor", "input", "loaded", "templateSelect", "subjectInput"]
  static values = { loaded: Boolean }

  editor = null

  connect() {
    if (this.loadedValue) {
      // musimy stworzyć edytor od nowa, bo inaczej nie będziemy mieli ustawionej wartości w this.editor
      const oldEditor = document.getElementsByClassName("jodit-container")[0]
      if (oldEditor) {
        oldEditor.remove()
      }
    }

    console.log("connect jodit")
    if (this.hasEditorTarget) {
      this.editor = this.createEditor()

      // autofocus - fokus na edytor po utworzeniu
      if (this.editorTarget.dataset.autofocus === "1") {
        setTimeout(() => {
          // dla ACE editor fokus na ukryty input
          const aceInput = this.element.querySelector(".ace_text-input")
          if (aceInput) {
            aceInput.focus()
          } else {
            this.editor.focus()
          }
        }, 100)
      }

      // wklej czysty tekst
      this.editor.events.on("keydown", (e) => {
        if ((e.ctrlKey || (e.metaKey && e.altKey)) && e.shiftKey && e.key.toLowerCase() === "v") {
          e.preventDefault()

          // Read plain text from clipboard
          navigator.clipboard.readText().then(text => {
            this.editor.selection.insertHTML(text.replace(/\n/g, "<br>"))
          }).catch(err => {
            console.error("Clipboard read error:", err)
          })
        }
      })
    }

    this.updateFooter() // w edycji bez tego nie pokazywał się footer
    this.loadedValue = true
    console.log(this.editor)
  }

  createEditor() {
    // Jodit.MODE_WYSIWYG = 1, Jodit.MODE_SOURCE = 2
    const sourceMode = this.editorTarget.dataset.sourceMode === "1"

    return new Jodit(`#${this.editorTarget.id}`, {
      link: {
        processVideoLink: false
      },
      style: { font: "14px Arial" },
      tabIndex: 0,
      autofocus: this.editorTarget.autofocus,
      cursorAfterAutofocus: "start",
      spellcheck: true, // Włącza sprawdzanie pisowni
      toolbarAdaptive: false,
      toolbarSticky: false,
      minHeight: "200px",
      defaultMode: sourceMode ? Jodit.MODE_SOURCE : Jodit.MODE_WYSIWYG,
      // sourceEditor: "area",
      colorPickerDefaultTab: "text",
      buttons: [
        "source", "|",
        "bold",
        "strikethrough",
        "underline",
        "italic", "|",
        "ul",
        "ol", "|",
        "outdent", "indent", "|",
        "font",
        "fontsize",
        "brush",
        "paragraph", "|",
        "image",
        "table",
        "link", "|",
        "align", "undo", "redo", "|",
        "hr",
        "eraser",
        "preview"
      ],
      controls: {
        paragraph: {
          list: Jodit.atom({
            p: "Pharagraph",
            h2: "Heading 1",
            h3: "Heading 2",
            h4: "Heading 3",
            h5: "Heading 4",
            blockquote: "Quote",
            pre: "Source code"
          })
        }
      },
      enter: "br",
      commandToHotkeys: {
        // https://mdn.github.io/dom-examples/execcommand/
        // zakomentowane opcje są domyślnie w jodit
        // undo: ["ctrl+z", "meta+z"],
        // redo: ["ctrl+shift+z", "meta+shift+z"],
        // bold: ["ctrl+b", "meta+b"],
        // italic: ["ctrl+i", "meta+i"],
        // underline: ["ctrl+u", "meta+u"],
        // createlink: ["ctrl+k", "meta+k"],
        // unlink: ["ctrl+shift+k", "meta+shift+k"], - nie działa w całości
        // insertorderedlist: ["ctrl+shift+7", "meta+shift+7"], - nie działa
        // insertunorderedlist: ["ctrl+shift+8", "meta+shift+8"], - nie działa
        // outdent: ["ctrl+[", "meta+["], - nie działa z powodu enter: "br"
        // indent: ["ctrl+]", "meta+]"], - nie działa z powodu enter: "br"
        // insertimage: ["ctrl+shift+i", "meta+shift+i"], - nie działa
        strikethrough: ["ctrl+shift+s", "meta+shift+s"],
        justifycenter: ["ctrl+e", "meta+e"],
        justifyfull: ["ctrl+j", "meta+j"],
        justifyleft: ["ctrl+l", "meta+l"],
        justifyright: ["ctrl+r", "meta+r"],
        inserthorizontalrule: ["ctrl+shift+-", "meta+shift+-"],
      },
      tabInsideLiInsertNewList: true,
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      showPlaceholder: false,
      askBeforePasteHTML: false,
      language: this.editorTarget.dataset.locale || "en",
      uploader: {
        url: this.editorTarget.getAttribute("data-direct-upload-url"),
        // insertImageAsBase64URI: true,
        imagesExtensions: ["jpg", "png", "jpeg", "gif", "svg", "webp"],
        format: "json",
        headers: {
          "X-CSRF-Token": document
            .querySelector("meta[name=\"csrf-token\"]")
            .getAttribute("content")
        },
        data: {
          in_text: "true",
          public: this.editorTarget.dataset.publicUpload || "false"
        },
        isSuccess: function (resp) {
          return !resp.error
        },
        getMessage: function (resp) {
          return resp.msg
        },
        process: function (resp) {
          return {
            attachments: resp.attachments || [],
            errors: resp.errors || [],
          }
        },
        defaultHandlerSuccess: function (data, _resp) {
          let i
          const field = "attachments"
          if (data[field] && data[field].length) {
            for (i = 0; i < data[field].length; i += 1) {
              console.log(data[field][i])
              const img = this.createInside.fromHTML(`<img src="${data[field][i].url}" src-old="${data[field][i].cid}">`)
              this.s.insertNode(img)
            }
          }

          if (data.errors && data.errors.length > 0) {
            this.message.message(data.errors.map(e => e.error + " " + e.attachment).join(", "), "error", 5000)
          }
        },
      },
      events: {
        beforePaste: function(event) {
          const items = (event.clipboardData || event.originalEvent.clipboardData).files
          const hasImage = items.length > 0
          const editorTarget = document.querySelector("[data-jodit-target='editor']")

          if (hasImage && (!editorTarget.hasAttribute("data-images") || editorTarget.dataset.images !== "1")) {
            this.fire("errorMessage", "Sorry, You can't paste image here")
            return false
          }

          return true
        }
      }
    })
  }

  insertTemplate(event) {
    const csrfToken = document.querySelector("[name=\"csrf-token\"]").content
    const templateId = event.currentTarget.value
    console.log("templateId", templateId)
    if (!templateId) { return }

    const url = event.currentTarget.dataset.url + "?template_id=" + templateId
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
    })
      .then(response => response.json())
      .then(data => this.insertTemplateData(data))
      .catch((error) => {
        console.error("Error:", error)
      })
  }

  insertTemplateData(data) {
    this.subjectInputTarget.value = data.subject
    const content = data.content
    // const editorDiv = this.editor.currentPlace.editor
    // debugger
    // usuwanie poprzedniego szablonu, znajdujemy pierwszy szablon z brzegu i sprawdzamy czy nic go nie poprzedza,
    // bo jesli tak to znaczy ze jest on juz wewnatrz tresci i nie chcemy go wywalac
    // const firstTemplate = document.querySelector('.intum_template')
    // console.log(firstTemplate, 'firstTemplate')
    // if (firstTemplate && firstTemplate.parentNode.firstChild === firstTemplate) { firstTemplate.remove() }

    const contentDiv = this.editor.createInside.element("div")
    contentDiv.classList.add("intum_template")
    contentDiv.innerHTML = content

    // to wywolanie umieszcza tresc szablonu na poczatku edytora
    this.editor.setEditorValue("")
    this.editor.s.insertNode(contentDiv)
    this.updateFooter()
  }

  updateEditor(event) {
    event.preventDefault()
    this.updateFooter()
  }

  updateFooter() {
    document.activeElement.blur()
    if (!this.hasInputTarget) { return }

    let input = ""

    if (this.inputTarget.tagName === "SELECT" && this.inputTarget.selectedOptions.length > 0) {
      input = this.inputTarget.selectedOptions[0].value
    } else {
      input = this.inputTarget.value
    }

    const id = this.inputTarget.dataset.id
    const url = this.inputTarget.dataset.url
    const intumReply = document.querySelector(".jodit-wysiwyg > .intum_reply")

    axios.get(url, {
      params: {
        [id]: input
      },
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => {
        console.log(response.data)
        let footer = document.querySelector(".jodit-wysiwyg > .intum_footer")

        if (footer) {
          if (response.data) {
            footer.outerHTML = response.data
          } else {
            footer.remove()
          }
        } else if (response.data) {
          footer = document.createElement("div")
          if (intumReply) {
            intumReply.parentNode.insertBefore(footer, intumReply)
          } else {
            const wysiwyg = document.querySelector(".jodit-wysiwyg")
            wysiwyg.appendChild(footer)
          }
          footer.outerHTML = response.data
        }

        this.setFocus()
      })
      .catch(error => {
        console.log("error updating")
        console.warn(error)
      })
  }

  setFocus() {
    const content = document.querySelector(".jodit-wysiwyg")
    if (content && content.firstChild) {
      this.editor.selection.setCursorBefore(content.firstChild)
    }
  }

  // czyszczenie edytora z lekkim opóźnieniem
  // (by formularz zdążył się najpierw wysłać w przypadku użycia funkcji po wysłaniu formularza)
  clearEditor() {
    if (this.editor) {
      setTimeout(() => {
        this.editor.value = ""
      }, 200)
    }
  }

  disconnect() {
    if (this.editor) {
      try {
        this.editor.remove()
      } catch (_e) {
        // Jodit może rzucić błąd gdy DOM jest już zniszczony (np. Turbo back)
      }
    }
  }
}
